import axios from 'axios';
import { toast } from 'react-toastify'
import { API_BASE_URL } from "../../config"
import { forceLogout } from '.';
import i18n from '../../langsconfig/i18n';


export const RequestHandler = async (method, API, params) => {

    const lang = i18n.language
    const controller = new AbortController();

    return await new Promise((resolve, reject) => {
        const isFormData = params instanceof FormData;
        
        const headers = {
            'Authorization': "Bearer " + localStorage.getItem("ut")
        };
        
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        axios({
            baseURL: API_BASE_URL,
            method,
            url: API + (lang ? (API.includes('?') ? '&' : '?') + 'culture=' + lang : ''),
            data: params || null,
            responseType:API.includes("/excel") || API.includes("/pdf") ? 'blob' : 'json',
            headers: headers,
            signal: controller.signal
        }).then(response => {
            resolve(response?.data)
        }).catch(error => {
            if (error.response?.status === 403) {
                forceLogout()
                return
            }

            toast.error(error.response?.data.message || error.message)

            reject(error)
        })
    })

}